import { InjectionToken } from "@angular/core";
import { App } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";

export const MESSAGING_LIFECYCLE = new InjectionToken<(onResume: () => void) => Promise<PluginListenerHandle>>(
  "MESSAGING_LIFECYCLE", {
    providedIn: "root",
    factory: () => onResume => App.addListener("appStateChange", state => { if (state.isActive) onResume(); }),
  },
);
